export enum PaginationSize {
  Small = 'small',
  Default = 'default'
}
